/**
 * Lazy-loading for images
 *
 * @package Globus
 * @since   1.0.0
 */

import 'picturefill';
import LazyLoad from 'vanilla-lazyload';
import objectFitImages from 'object-fit-images';

/**
 * Kick-off lazy-loading, while reevaluating picturefill in the process.
 *
 * @since 1.0.0
 * @since 1.0.1 Added object-fit support to images that aren't lazyloaded.
 * @since 1.2.1 Replace data-original with default data-src selector.
 */
function initImages() {
	/**
	 * Lazyload all images that have the lazyImageSelector, while reevaulating picturefill,
	 * and running objectFitImages.
	 */
	// eslint-disable-next-line no-unused-vars
	const lazyload = new LazyLoad(
		{
			container: document.querySelector('.site'),
			show_while_loading: true,
			callback_set: (img) => {
				// eslint-disable-next-line no-undef
				picturefill(
					{
						reevaluate: true,
						elements: [img],
					},
				);
				objectFitImages(img);
			},
		},
	);

	/**
	 * Handle object fit images that aren't being lazy loaded.
	 */
	const nonLazyImages = document.querySelectorAll('img:not([data-src])');
	if (nonLazyImages.length > 0) {
		objectFitImages(nonLazyImages);
	}
}

window.addEventListener('DOMContentLoaded', initImages);
